<template>
  <div>
    <v-divider></v-divider>
    <p>{{$t('fieldAgent')}}: {{customer.fieldAgent.name}}</p>
    <p>{{$t('farmer')}}: {{customer.name}}</p>
  </div>
</template>

<script>
export default {
  props: ['customer']
}
</script>

<style scoped>

</style>